<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Storage Service - File Sharing Service Setup</h4>
        <p>Note: To enable Samba Server, at least one samba user account would be set, and also need a storage device. To add a samba user, please entry the page "Storage User Accounts".</p>
        <el-form 
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Open Samba:">
                <el-switch v-model="flag"  @change="changes" ></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      flag: false,
      isFountUsb: false
    };
  },
  methods: {
    getData() {
      let postdata = {
        CmdType: "GET_SAMBASWITCH"
      };
      this.loading = true;
      axios.post("/boafrm/formSambaSwirch", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data == "undefined" || data == "" || data.ret == "-1") {
          this.$message.error("Data acquisition failure!");
          return;
        }

        this.isFountUsb = data.isFountUsb;
        if (data.sambaSwitch == "1") {
          this.flag = true;
        } else {
          this.flag = false;
        }
      });
    },
    save() {
      if (this.flag == true) {
        var type = 1;
      } else {
        var type = 0;
      }
      let postdata = {
        CmdType: "SET_SAMBASWITCH",
        sambaSwitch: type
      };
      this.loading = true;
      axios.post("/boafrm/formSambaSwirch", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data.ret == "0") {
          this.$message.success("Configured successfully!");
        } else {
          this.$message.error("Configuration failed!");
        }
      });
    },
     changes() {
      if (this.flag == true) {
        if (!this.isFountUsb) {
            this.flag=false;
            this.$message.error("Did not find USB device, can not open!");
          return;
        }
      }
    }
  },
  created() {
    this.getData();
  }
};
</script>



